import { InvestmentDetailsRowItemStyles } from '../InvestmentDetailsRowItem/InvestmentDetailsRowItem.styles.tsx';
import { ReactNode } from 'react';

interface Props {
	label: ReactNode;
	content?: ReactNode;
	hideBorder?: boolean;
	align?: 'center' | 'flex-start';
	truncate?: boolean;
}

export const InvestmentDetailsRowItem = ({
	label,
	content,
	hideBorder = false,
	align = 'center',
	truncate = false,
}: Props) => {
	return (
		<InvestmentDetailsRowItemStyles
			className={hideBorder ? 'no-border' : ''}
			style={{ alignItems: align }}
			$truncate={truncate}
		>
			{label}

			{content}
		</InvestmentDetailsRowItemStyles>
	);
};
